// utils/formatJSON.js

/**
 * Converts FAQ data into formatted JSON (pretty-printed)
 *
 * @param {Array} data - The FAQ data array
 * @param {string} language - The current language
 * @returns {string} Formatted JSON string
 */
export function convertToJSON(data, language = 'en') {
  if (!Array.isArray(data)) return JSON.stringify({ faqs: [] }, null, 2);

  const structured = {
    language,
    generatedAt: new Date().toISOString(),
    faqs: data.map(category => ({
      categoryName: category.categoryName || 'Untitled Category',
      items: (category.details || category.faqList || []).map(item => ({
        question: item.question || item.title || '',
        answer: item.answer || item.description || ''
      }))
    }))
  };

  return JSON.stringify(structured, null, 2);
}
